import { render, staticRenderFns } from "./FixedSaveBtn.vue?vue&type=template&id=5d4bfbbe&scoped=true&"
import script from "./FixedSaveBtn.vue?vue&type=script&lang=js&"
export * from "./FixedSaveBtn.vue?vue&type=script&lang=js&"
import style0 from "./FixedSaveBtn.vue?vue&type=style&index=0&id=5d4bfbbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4bfbbe",
  null
  
)

export default component.exports